import Storage from '../storage/index';
import CodiSystem from '../codiSystem/index';
import FrontCubeData from '../frontCubeData/index';
import DragSyStem from '../dragSyStem/index';
import Config from '../config/index';
import Select from '../interaction/select/index';
import History from '../interaction/history/index';
import Shortcutkey from '../interaction/shortcutkey/index';
import { StageEvent } from '../message/index';

export default function cleanSystem(): void {
    $('.J_LayoutStageMain').html('');
    // Storage.clear();
    CodiSystem.clear();
    FrontCubeData.clear();
    Config.reset();
    StageEvent.clearAll();
    Select.cleanSystem();
    Shortcutkey.destroy();
    DragSyStem.clear();
    History.clear();
}
